export enum SchedulingType {
	PREVENTIVA = 'preventiva',
	CORRETIVA = 'corretiva',
	GUINCHO = 'guincho',
}

export const SchedulingTypeReviewLabelIdMap: Record<SchedulingType, string> = {
	[SchedulingType.PREVENTIVA]: "intl-msg:shared.schedulingType.review.preventiva",
	[SchedulingType.CORRETIVA]: "intl-msg:shared.schedulingType.review.corretiva",
	[SchedulingType.GUINCHO]: "intl-msg:shared.schedulingType.review.guincho",
};